export default "__VITE_ASSET__BMQa1jVY__"